var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.unreadCount),expression:"unreadCount"}],staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.unreadCount))])
}
var staticRenderFns = []

export { render, staticRenderFns }